<script setup>
import {computed} from "vue";
import {getLogo} from "@/helpers/logo";
import {getNoun} from "@/helpers/string";

const {need} = defineProps(['need']);

const displayedStartups = computed(() => {
    return need.startups.slice(0, 6);
});
</script>

<template>
    <div>
        <div class="carousel-slide__item">
            <div class="card-needs">
                <div class="card-needs__content">
                    <h5 class="heading5 heading5--secondary">
                        {{need.name}}
                    </h5>
                    <p>{{ need.startups.length }} new AI {{getNoun('match', need.startups.length, 'matches' )}} </p>

                    <ul class="list-matches">
                        <li v-for="startup in displayedStartups" :key="startup.id">
                            <a :href="`/startups/${startup.id}`" target="_blank">
                                <img :src="getLogo(startup.logo)" alt="" />
                            </a>
                        </li>
                    </ul>
                </div>
                <footer class="card-needs__footer">
                    <a :href="`/needs/${need.id}?openMatchMaking=1`" target="_blank" class="link-arrow">Review</a>
                </footer>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
